<div
  *ngIf="isOpen"
  class="weight-calculator-overlay"
  role="presentation"
  (click)="close()"
>
  <section
    class="weight-calculator-dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="weight-calculator-title"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    (click)="$event.stopPropagation()"
  >
    <header class="dialog-header">
      <h2 id="weight-calculator-title">Weight Calculator</h2>
      <button class="icon-button" type="button" aria-label="Close weight calculator" (click)="close()">&times;</button>
    </header>

    <div class="dialog-body">
      <p class="instruction">Enter desired weight for:</p>

      <div class="weight-inputs">
        <label for="blend-1-weight">Prediction 1 <span>(grams)</span></label>
        <input id="blend-1-weight" name="blend1Weight" type="number" step="0.01" [(ngModel)]="blend1Weight" [attr.aria-invalid]="!isValidWeight(blend1Weight)" aria-describedby="blend-1-weight-error" />
        <p *ngIf="!isValidWeight(blend1Weight)" class="validation-message" id="blend-1-weight-error">{{ weightError(blend1Weight) }}</p>

        <label for="blend-2-weight">Prediction 2 <span>(grams)</span></label>
        <input id="blend-2-weight" name="blend2Weight" type="number" step="0.01" [(ngModel)]="blend2Weight" [attr.aria-invalid]="!isValidWeight(blend2Weight)" aria-describedby="blend-2-weight-error" />
        <p *ngIf="!isValidWeight(blend2Weight)" class="validation-message" id="blend-2-weight-error">{{ weightError(blend2Weight) }}</p>
      </div>

      <div class="print-summary" aria-label="Blend sheet total weights">
        <p><strong>Prediction 1 total:</strong> {{ blend1Weight }} g</p>
        <p><strong>Prediction 2 total:</strong> {{ blend2Weight }} g</p>
      </div>

      <div class="weight-table" role="table" aria-label="Weight calculator component rows">
        <div class="weight-row table-header" role="row">
          <span class="component-name" role="columnheader">Selections</span>
          <span class="group-header prediction-1" role="columnheader">Prediction 1</span>
          <span class="group-header prediction-2" role="columnheader">Prediction 2</span>
        </div>
        <div class="weight-row table-subheader" role="row">
          <span role="columnheader"></span>
          <span class="prediction-1" role="columnheader">wt%</span>
          <span class="prediction-1" role="columnheader">Grams</span>
          <span class="prediction-2" role="columnheader">wt%</span>
          <span class="prediction-2" role="columnheader">Grams</span>
        </div>

        <div *ngFor="let row of rows" class="weight-row" role="row">
          <span class="component-name" role="cell">{{ row.name }}</span>
          <span class="prediction-1" role="cell">{{ row.p1.wtPct !== null ? (row.p1.wtPct | number: '1.2-2') : '' }}</span>
          <span class="prediction-1" role="cell">{{ row.p1.grams !== null ? (row.p1.grams | number: '1.2-2') : '' }}</span>
          <span class="prediction-2" role="cell">{{ row.p2.wtPct !== null ? (row.p2.wtPct | number: '1.2-2') : '' }}</span>
          <span class="prediction-2" role="cell">{{ row.p2.grams !== null ? (row.p2.grams | number: '1.2-2') : '' }}</span>
        </div>

        <div *ngIf="rows.length > 0" class="weight-row total-row" role="row">
          <span class="component-name" role="cell">Total</span>
          <span class="prediction-1" role="cell">{{ totals.p1.wtPct !== null ? (totals.p1.wtPct | number: '1.2-2') : '' }}</span>
          <span class="prediction-1" role="cell">{{ totals.p1.grams !== null ? (totals.p1.grams | number: '1.2-2') : '' }}</span>
          <span class="prediction-2" role="cell">{{ totals.p2.wtPct !== null ? (totals.p2.wtPct | number: '1.2-2') : '' }}</span>
          <span class="prediction-2" role="cell">{{ totals.p2.grams !== null ? (totals.p2.grams | number: '1.2-2') : '' }}</span>
        </div>

        <div *ngIf="rows.length === 0" class="empty-row" role="row">
          <span class="empty-icon material-icons-outlined" aria-hidden="true">science</span>
          <span role="cell">Pick something to calculate</span>
        </div>
      </div>
    </div>
    <footer class="dialog-actions">
      <button
        class="secondary-button print-button"
        type="button"
        title="Print blend sheet"
        [disabled]="!canPrint"
        (click)="print()">
        <span class="material-icons-outlined" aria-hidden="true">print</span>
        <span>Print</span>
      </button>
    </footer>
  </section>
</div>
